import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=26963060&scoped=true"
import script from "./camera.vue?vue&type=script&lang=js"
export * from "./camera.vue?vue&type=script&lang=js"
import style0 from "./camera.vue?vue&type=style&index=0&id=26963060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26963060",
  null
  
)

export default component.exports